import { render } from "./Children.vue?vue&type=template&id=34e2dd07"
import script from "./Children.vue?vue&type=script&lang=js"
export * from "./Children.vue?vue&type=script&lang=js"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__